import * as React from "react";
import { Create, FormTab, TabbedForm } from "react-admin";
import { ContentTab } from "./edit/components/ContentTab";
import { StructureTab } from "./edit/components/StructureTab";
import { AssetPathsTab } from "./edit/components/AssetPathsTab";
import { DetailFields } from "./edit/components/DetailFields";

const validateProgram = (values) => {
  const errors = {};
  if (!values.title) {
    errors.title = "ra.validation.required";
  }
  if (!values.slug) {
    errors.slug = "ra.validation.required";
  } else if (!/^[a-z0-9-]+$/.test(values.slug)) {
    errors.slug = "Slug must be lowercase letters, numbers, and hyphens only";
  }
  return errors;
};

export const ProgramCreate = (props) => (
  <Create {...props} mutationMode="pessimistic">
    <TabbedForm validate={validateProgram} warnWhenUnsavedChanges>
      <FormTab label="details">
        <DetailFields isCreate />
      </FormTab>
      <FormTab label="content">
        <ContentTab source="content" />
      </FormTab>
      <FormTab label="structure">
        <StructureTab source="blocks" />
      </FormTab>
      <FormTab label="asset paths">
        <AssetPathsTab />
      </FormTab>
    </TabbedForm>
  </Create>
);
